<template>
  <div class="comments">
    <div> <!-- Title -->
      <p class="has-text-weight-bold is-size-4">{{ $t('comments-view.title') }}</p>
    </div>
    <b-table class="mt-4" :data="commentsData" :mobile-cards="false" :scrollable="true" :show-header="false">
      <b-table-column field="meta.user" v-slot="commentprops">
        <div class="columns" style="margin-top: 8px; margin-bottom: 8px;">
          <div class="column is-2">
            <p class="has-text-weight-bold">{{ getFullName(commentprops.row.meta.user.name) }}</p>
            <p class="is-size-7">{{ getFormattedDateTime(commentprops.row.insert_ts) }}</p>
          </div>
          <div class="column">
            <b-message>
              {{ commentprops.row.text }}
            </b-message>
            <div class="columns">
              <div class="column"></div>
              <div class="column is-narrow">
                <b-button v-if="!commentprops.row.isInReplyMode" class="button is-primary is-small" @click="replyCommentClicked(commentprops.row)" icon-left="reply">
                  {{ $t('comments-view.reply-button') }}
                </b-button>
              </div>
              <div class="column is-narrow">
                <b-button v-if="isCurrentUser(commentprops.row.user_id) || currentUserAdminAccessLevel()"
                          class="button is-primary is-danger is-small" icon-left="delete"
                          @click="deleteCommentClicked(commentprops.row.document_id)">
                  {{ $t('comments-view.delete-comment-button') }}
                </b-button>
              </div>
            </div>
            <div v-if="commentprops.row.isInReplyMode" class="columns m-3 mt-4 mr-6">
              <div class="column is-2"></div>
              <div class="column is-10">
                <b-field>
                  <b-input v-model="commentprops.row.subCommentText" type="textarea"></b-input>
                </b-field>
                <div class="columns">
                  <div class="column"></div>
                  <div class="column is-narrow">
                    <b-button class="button is-small" @click="replyCommentClicked(commentprops.row)">
                      {{ $t('comments-view.reply-comment-cancel-button') }}
                    </b-button>
                  </div>
                  <div class="column is-narrow">
                    <b-button class="button is-primary is-small" @click="createSubCommentClicked(commentprops.row)">
                      {{ $t('comments-view.reply-comment-button') }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Replied Comments -->
        <b-table class="mt-4" :data="commentprops.row.projectssubcomments" :mobile-cards="false" :scrollable="true"
                 :show-header="false">
          <b-table-column field="meta.user" v-slot="subprops">
            <div class="columns" style="margin-top: 4px; margin-bottom: 4px; margin-left: 32px">
              <div class="column is-2">
                <p class="has-text-weight-bold">{{ getFullName(subprops.row.user.name) }}</p>
                <p class="is-size-7">{{ getFormattedDateTime(subprops.row.insert_ts) }}</p>
              </div>
              <div class="column">
                <b-message>
                  {{ subprops.row.text }}
                </b-message>
              </div>
              <div class="column is-narrow">
                <b-button v-if="isCurrentUser(subprops.row.user_id) || currentUserAdminAccessLevel()"
                          class="button is-primary is-danger is-small" icon-left="delete"
                          @click="deleteCommentClicked(commentprops.row.document_id, subprops.row.document_id)">
                </b-button>
              </div>
            </div>
          </b-table-column>
        </b-table>
      </b-table-column>
    </b-table>
    <div class="columns m-3 mt-4 mr-6">
      <div class="column is-2"></div>
      <div class="column is-10">
        <b-field>
          <b-input v-model="commentText" type="textarea"></b-input>
        </b-field>
        <div class="columns">
          <div class="column"></div>
          <div class="column is-narrow">
            <b-button class="button is-primary mt-3" @click="createCommentClicked">
              {{ $t('comments-view.create-comment') }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "Comments",
  props: {
    'document_id': {
      type: String,
    }
  },
  data() {
    return {
      commentsData: [],
      commentText: ""
    }
  },
  methods: {
    readCommentsData: function () {
      this.$parent.isLoading = true
      this.commentsData = []
      const functions = firebase.app().functions("europe-west3");
      const getCommentsFunction = functions.httpsCallable(this.getSubmitEndpoint());
      const payload = {
        action: "get_comments",
        project_id: this.document_id,
        fill_meta: true,
        order_by: "modify_ts",
        order_direction: "ascending"
      }
      console.log("get_comments payload: ", payload);
      getCommentsFunction(payload)
          .then((result) => {
            this.$parent.isLoading = false
            result.data["projectscomments"].forEach((comment) => {
              comment.isInReplyMode = false
              comment.subCommentText = ""
              this.commentsData.push(comment)
            })
            console.log("get_comments result: ", result.data);
          })
          .catch((error) => {
            this.$parent.isLoading = false
            this.showError(error.message)
            console.log("Error get_comments: ", error);
          });
    },
    createCommentClicked: function () {
      this.$parent.isLoading = true
      const functions = firebase.app().functions("europe-west3");
      const insertCommentFunction = functions.httpsCallable(this.getSubmitEndpoint());
      const payload = {
        action: "insert_comment",
        project_id: this.document_id,
        user_id: this.getLocalUserId(),
        text: this.commentText
      }
      console.log("insert_comment payload: ", payload);
      insertCommentFunction(payload)
          .then((result) => {
            this.$parent.isLoading = false
            this.commentText = ""
            this.readCommentsData()
            console.log("insert_comment result: ", result.data);
          })
          .catch((error) => {
            this.$parent.isLoading = false
            this.showError(error.message)
            console.log("Error insert_comment: ", error);
          });
    },
    createSubCommentClicked: function (comment) {
      this.$parent.isLoading = true
      const functions = firebase.app().functions("europe-west3");
      const insertCommentFunction = functions.httpsCallable(this.getSubmitEndpoint());
      const payload = {
        action: "insert_comment",
        project_id: this.document_id,
        user_id: this.getLocalUserId(),
        comment_id: comment.document_id,
        text: comment.subCommentText
      }
      console.log("subComment insert_comment payload: ", payload);
      insertCommentFunction(payload)
          .then((result) => {
            this.$parent.isLoading = false
            this.commentText = ""
            comment.subCommentText = ""
            this.readCommentsData()
            console.log("subComment insert_comment result: ", result.data);
          })
          .catch((error) => {
            this.$parent.isLoading = false
            this.showError(error.message)
            console.log("Error subComment insert_comment: ", error);
          });
    },
    deleteComment: function (commentId, subCommentId) {
      this.$parent.isLoading = true;
      const functions = firebase.app().functions("europe-west3");
      const deleteCommentFunction = functions.httpsCallable(this.getSubmitEndpoint());
      const deleteCommentPayload = {
        action: "delete_comment",
        project_id: this.document_id,
        document_id: commentId
      }
      console.log("Delete comment payload: ", deleteCommentPayload);
      // in case we are deleting a sub-comment
      if (subCommentId !== undefined && subCommentId !== "" && subCommentId !== null) {
        deleteCommentPayload.comment_id = commentId
        deleteCommentPayload.document_id = subCommentId
      }
      console.log("Delete comment payload: ", deleteCommentPayload);
      deleteCommentFunction(deleteCommentPayload).then(() => {
        this.$parent.isLoading = false;
        this.showSuccess(this.$t('comments-view.comment-deleted'));
        this.readCommentsData()
      }).catch((error) => {
        this.$parent.isLoading = false;
        this.showError(error.message)
        console.log("Error deleting comment: ", error);
      });
    },
    deleteCommentClicked: function (commentId, subCommentId) {
      this.$buefy.dialog.confirm({
        title: this.$t('comments-view.delete-comment-title').toString(),
        message: this.$t('comments-view.delete-comment-message').toString(),
        confirmText: this.$t('comments-view.delete-comment-button').toString(),
        cancelText: this.$t('common.cancel').toString(),
        type: 'is-danger',
        hasIcon: true,
        icon: 'delete',
        onConfirm: () => {
          this.deleteComment(commentId, subCommentId);
        }
      });
    },
    replyCommentClicked: function (comment) {
      console.log("reply on: ", comment.text)
      if (comment.isInReplyMode === undefined || comment.isInReplyMode === "" || comment.isInReplyMode === null) {
        comment.isInReplyMode = true
      } else {
        comment.isInReplyMode = !comment.isInReplyMode
      }
    }
  },
  mounted() {
    this.readCommentsData();
  }
}
</script>

<style scoped>

</style>